import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store,persistor} from './store';
import { Provider } from 'react-redux';
import {BrowserRouter} from 'react-router-dom'
import {PersistGate} from 'redux-persist/integration/react';
import ModalLoader from './components/helpers/ModalLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <React.StrictMode> */}
        <PersistGate loading={<ModalLoader color="#F67280" size={17}/>} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      {/* </React.StrictMode> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
